import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from "../services/session.service";
import { MasterDataService } from "../services/masterdata.service";
import { SubscriptionSearch } from "../services/subscription-search.service";
import { UserRolesService } from "../services/user-roles.service";
import { SubscriptionSearchData } from "../models/subscription-search-data";

@Component({
    selector: "app-search-subscription",
    templateUrl: "./search-subscription.component.html",
    styleUrls: ["./search-subscription.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchSubscriptionComponent implements OnInit {
    private subscription: Subject<void> = new Subject<void>();
    public masterData: any;
    public IsActive: boolean = false;
    public ApprovalPending: boolean = false;
    public IsHold: boolean = false;
    public IsInactive: boolean = false;
    public ExternalClient: boolean = false;
    public ExternalNonClient: boolean = false;
    public MixedAudience: boolean = false;
    public IsCancelled: boolean = false;
    public selectedSubscriptionId: string = "";
    public selectedSubscriptionName: string = "";
    public selectedCompanyName: any; //string = "";
    public selectedSubscriptionAdmin: string = "";
    public startDate: any;
    public endDate: any;
    public showTable: boolean = false;
    public sessionStartDate: any;
    public sessionEndDate: any;
    public IsDateInvalid: boolean = false;
    public invalidDateErrorMsg: string = "";
    public enableSearchBtn: boolean = false;
    public enableClearBtn: boolean = false;
    public isEnableExportBtn: boolean = false;
    public totalRecords: number = 0;
    public subscriptionStatusList: Array<any>;
    public subscriptionAudienceList: Array<any>;
    public searchFailed: boolean = false;
    public searching: boolean = false;

    public sampleColumns: any;
    public sampleData: SubscriptionSearchData[];
    public allowCheckbox: boolean = false;
    public iseventRegistered: boolean = true;
    public allowPagination: boolean = false;
    public isClientSidePagination: boolean = true;
    public isSubscriptionModule: boolean = true;

    public showLoaderIcon: boolean = false;
    searchGridHeight: any;
    searchAreaFields: boolean = true;
    seaerchAreaDownArrow: boolean = false;
    seaerchAreaUpArrow: boolean = false;
    isCompName = false;
    compNameErrorMsg = "";
    selectedSubscriptionType = "";
    SubscriptionType: any;
    SubscriptionTypeMasterData: any;
    isExpandSearchFields: boolean = false;
    userRoleID: any;
    constructor(
        private sessionService: SessionService,
        private subscriptionSearchService: SubscriptionSearch,
        private masterDataService: MasterDataService,
        private userRoleService: UserRolesService
    ) {
        this.subscriptionStatusList = [];
        this.subscriptionAudienceList = [];
        this.sessionStartDate = "";
        this.sessionEndDate = "";
        this.sampleData = [];
        this.totalRecords = 0;
    }

    ngOnInit() {
        this.SubscriptionTypeMasterData = [{
            id: 1, name: "Standard"
        }, {
          id: 2, name: "Digital Experience"
        },
        {
            id: 3, name: "Commercialization"
        }
        ];
        this.userRoleService.getUserRoleID().subscribe((res) => {
            this.userRoleID = res;
            this.setSubscriptionType();

            this.masterDataService
                .getMasterDataDetails()
                .pipe(takeUntil(this.subscription))
                .subscribe((masterData) => {
                    if (masterData) {
                        this.masterData = masterData;
                        this.reloadPageWithData(true); //persisting
                    }
                });
        });
    }
    @ViewChild("headerHeight")
    headerHeight: ElementRef;
    @ViewChild("searchFieldsHeight", { static: true })
    searchFieldsHeight: ElementRef;
    onResize(event) {
        if (!this.isExpandSearchFields) {
            this.searchGridHeightSet();
        } else {
            setTimeout(() => {
                var SearchFildsHeight =
                    this.searchFieldsHeight.nativeElement.offsetHeight;
                const screenHeight = window.innerHeight;
                const totalDedVal = SearchFildsHeight - 100;
                return (this.searchGridHeight = screenHeight - totalDedVal + "px");
            }, 300);
        }
    }

    setSubscriptionType() {
      if (this.userRoleID == 3 || this.userRoleID == 6) {
            this.selectedSubscriptionType = "Standard";
            this.SubscriptionType = this.SubscriptionTypeMasterData.filter(x => x.name == "Standard");
            this.onChangeOfInputFields();
        }
        else {
            this.SubscriptionType = this.SubscriptionTypeMasterData;
            this.selectedSubscriptionType = "";
        }
    }


    searchGridHeightSet() {
        setTimeout(() => {
            var SearchFildsHeight =
                this.searchFieldsHeight.nativeElement.offsetHeight;
            const screenHeight = window.innerHeight;
            const totalDedVal = SearchFildsHeight + 230;
            return (this.searchGridHeight = screenHeight - totalDedVal + "px");
        }, 300);
    }

    searchAreaExpand() {
        this.searchAreaFields = true;
        this.seaerchAreaDownArrow = false;
        this.seaerchAreaUpArrow = true;
        this.searchGridHeight = "400px";
        this.isExpandSearchFields = true;
    }

    searchAreaCollapse() {
        this.isExpandSearchFields = false;
        this.searchAreaFields = false;
        this.seaerchAreaDownArrow = true;
        this.seaerchAreaUpArrow = false;
        this.searchGridHeightSet();
    }



    validateFields() {
        if (
            this.selectedCompanyName.length < 3 &&
            this.selectedCompanyName.length > 0
        ) {
            this.enableSearchBtn = false;
            this.isCompName = true;
            this.compNameErrorMsg =
                "Please enter at least 3 characters to perform search.";
        } else if (
            this.selectedCompanyName.length == 0 ||
            this.selectedCompanyName.length > 2
        ) {

            this.isCompName = false;
            this.compNameErrorMsg = "";
        }
    }
    // Data Persist
    reloadPageWithData(flag?) {
        this.subscriptionStatusList = [];
        this.subscriptionAudienceList = [];
        const searchResult = this.masterDataService.subscriptionSearchData;
        if (searchResult != undefined) {
            if (searchResult != "") {
                this.selectedSubscriptionId = searchResult.SubscriptionuniqeID
                    ? searchResult.SubscriptionuniqeID
                : "";
              this.selectedSubscriptionName = searchResult.SubscriptionName
                ? searchResult.SubscriptionName
                : "";
                this.selectedSubscriptionAdmin = searchResult.SubscriptionAdmin
                    ? searchResult.SubscriptionAdmin
                    : "";
                this.selectedSubscriptionType = searchResult.SubscriptionType
                    ? searchResult.SubscriptionType
                    : "";
                const persistStatusValue = searchResult.SubscriptionStatus
                    ? searchResult.SubscriptionStatus.split(",")
                    : [];
                this.setSubscriptionStatus(persistStatusValue);

                const persistAudienceValue = searchResult.SessionAudience
                    ? searchResult.SessionAudience.split(",")
                    : [];
                this.setSubscriptionAudience(persistAudienceValue);

                const tempCompanyName = searchResult.Company ? searchResult.Company : "";
                if (tempCompanyName == "") {
                    this.selectedCompanyName = "";
                } else {
                    this.selectedCompanyName = { Name: tempCompanyName };
                }

                this.sessionStartDate = searchResult.StartDate
                    ? searchResult.StartDate
                    : "";
                this.sessionEndDate = searchResult.EndDate ? searchResult.EndDate : "";

                // Setting the Data
                this.startDate = this.setStartEndDate(this.sessionStartDate);
                this.endDate = this.setStartEndDate(this.sessionEndDate);

                this.onChangeOfInputFields();
                if (flag) {
                    this.getSearchData();
                }
            }
        }
    }

    setSubscriptionStatus(statusValueList) {
        if (statusValueList.length > 0) {
            statusValueList.forEach((item) => {
                if (item == "Approval Pending") {
                    this.ApprovalPending = true;
                    this.setStatusCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "Active") {
                    this.IsActive = true;
                    this.setStatusCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "Hold") {
                    this.IsHold = true;
                    this.setStatusCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "Inactive") {
                    this.IsInactive = true;
                    this.setStatusCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "Cancelled") {
                    this.IsCancelled = true;
                    this.setStatusCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
            });
        } else {
            this.subscriptionStatusList = [];
        }
    }
    setSubscriptionAudience(audienceValueList) {
        if (audienceValueList.length > 0) {
            audienceValueList.forEach((item) => {
                if (item == "ExternalClient") {
                    this.ExternalClient = true;
                    this.setAudienceCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "ExternalNonClient") {
                    this.ExternalNonClient = true;
                    this.setAudienceCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                if (item == "MixedAudience") {
                    //Bug 3722855 fix
                    this.MixedAudience = true;
                    this.setAudienceCheckboxValue(item, true);
                    this.onChangeOfInputFields();
                }
                
            });
        } else {
            this.subscriptionAudienceList = [];
        }
    }
    setStartEndDate(inputDate) {
        const tempStartDate = this.ConvertDateToStringFormat(inputDate);

        return new NgbDate(
            Number(tempStartDate.year),
            Number(tempStartDate.month),
            Number(tempStartDate.day)
        );
    }

    ConvertDateToStringFormat(dt) {
        dt = new Date(dt);
        var dateObj = { day: "", month: "", year: 0 };
        var day = ("" + dt.getDate()).slice(-2);
        var month = ("" + (dt.getMonth() + 1)).slice(-2);
        dateObj.day = day;
        dateObj.month = month;
        dateObj.year = dt.getFullYear();
        return dateObj;
    }

    // Data Persist
    setDataOnTabChange() {
        let compName;

        if (this.selectedCompanyName) {
            compName = this.selectedCompanyName;
        }

        if (!compName) {
            compName = "";
        }

        if (compName.Name) {
            compName = compName.Name;
        }
        const inputData = {
            SubscriptionuniqeID: this.selectedSubscriptionId,
            SubscriptionName: this.selectedSubscriptionName,
            SubscriptionAdmin: this.selectedSubscriptionAdmin,
            SubscriptionType: this.selectedSubscriptionType,
            SubscriptionStatus: this.subscriptionStatusList.toString(),
            SessionAudience: this.subscriptionAudienceList.toString(),
            Company: compName,
            StartDate: this.sessionStartDate,
            EndDate: this.sessionEndDate,
        };

        this.masterDataService.subscriptionSearchData = inputData;
    }



    setDateFormat(event) {
        if (event) {
            const year = event.year;
            const month = event.month <= 9 ? "0" + event.month : event.month;
            const day = event.day <= 9 ? "0" + event.day : event.day;
            const finalDate = year + "/" + month + "/" + day;
            return finalDate;
        } else {
            return "";
        }
    }

    public minDate: { year: number; month: number; day: number };

    onStartDateSelect(event) {
        this.sessionStartDate = this.setDateFormat(event);
        this.minDate = this.getdisabledDate(this.sessionStartDate); //to disabled the date before start date for End date field
    }

    // to disabled the date before start datet for End date field
    getdisabledDate(dt) {
        dt = new Date(dt);

        const day = ("" + dt.getDate()).slice(-2);
        const month = ("" + (dt.getMonth() + 1)).slice(-2);
        const dateObj = { year: dt.getFullYear(), month: Number(month), day: Number(day) + 1 }; 
        return dateObj;
    }

    onEndDateSelect(event) {
        this.sessionEndDate = this.setDateFormat(event);

        if (
            this.sessionStartDate != "" &&
            this.sessionStartDate > this.sessionEndDate
        ) {
            this.IsDateInvalid = true;
            this.invalidDateErrorMsg = "From Date should be greater than To Date.";
        } else {
            this.IsDateInvalid = false;
            this.invalidDateErrorMsg = "";
        }
    }

    public setStatusCheckboxValue(name, isChecked: boolean) {
        if (isChecked) {
            this.subscriptionStatusList.push(name);
        } else {
            const index = this.subscriptionStatusList.indexOf(name);
            this.subscriptionStatusList.splice(index, 1);
        }
    }
    public setAudienceCheckboxValue(name, isChecked: boolean) {
        if (isChecked) {
            //Bug 3722855 fix
            if(this.subscriptionAudienceList.length > 0) {
                    if(this.subscriptionAudienceList.indexOf(name) == -1){
                        this.subscriptionAudienceList.push(name);
                    }
            }
            else {
                this.subscriptionAudienceList.push(name);
            }
            
        } else {
            const index = this.subscriptionAudienceList.indexOf(name);
            this.subscriptionAudienceList.splice(index, 1);
        }
    }

    formatMatches = (value: any) => {
        if (typeof value == 'object') {
            return value.Name
        }
        else if (typeof value == 'string') {
            return value
        }
        else {
            return null
        }

    };

    searchCompanies = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => (this.searching = true)),
            switchMap((term) =>
                this.subscriptionSearchService.searchword(term, 0).pipe(
                    tap(() => (this.searchFailed = false)),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    })
                )
            ),
            tap(() => (this.searching = false))
        );

  exportData() {
        this.showLoaderIcon = true;
        const subscriptionUniqueIds = [];
        this.sampleData.forEach(e => {
          subscriptionUniqueIds.push(e.SubscriptionuniqeID);
        })
        this.subscriptionSearchService.exportReport(subscriptionUniqueIds).subscribe((res) => {
            var binaryData = [];
            binaryData.push(res);
            const url = window.URL.createObjectURL(
                new Blob(binaryData, { type: "application/vnd.ms-excel" })
            );
            // create hidden dom element (so it works in all browsers)
            const a = document.createElement("a");
            a.setAttribute("style", "display:none;");
            document.body.appendChild(a);
            // create file, attach to hidden element and open hidden element
            a.href = url;
            a.download = "SubscriptionSearchExportReport.xls";
            a.click();
            this.showLoaderIcon = false; 
        });
    }

    setColumnHeading() {
        this.sampleColumns = [
            {
                name: "SubscriptionStatus",
                header: "Status",
                dataType: "string",
                minWidth: "60",
            },
            {
                name: "SubscriptionuniqeID",
                header: "ID",
                dataType: "string",
                minWidth: "100px",
            },
            {
              name: "SubscriptionName",
              header: "Name",
              dataType: "string",
              minWidth: "100px",
            },

            {
                name: "StartDate",
                header: "Start Date",
                dataType: "date",
                minWidth: "60px",
            },
            {
                name: "EndDate",
                header: "End Date",
                dataType: "date",
                minWidth: "60px",
            },
            {
                name: "SessionAudience",
                header: "Session Audience",
                dataType: "string",
                minWidth: "100px",
            },
            {
                name: "SubscriptionType",
                header: "Subscription Type",
                dataType: "string",
                minWidth: "100px",
            },            
            {
                name: "Company",
                header: "Company/Organization",
                dataType: "string",
                minWidth: "80px",
            },
            {
                name: "maxusers",
                header: "# Users",
                dataType: "number",
                minWidth: "100px",
            },

            {
                name: "ActualUsers",
                header: "Actual Users",
                dataType: "number",
                minWidth: "100px",
            },
            
        ];
    }

    getSearchData() {
        let compName;
        this.showLoaderIcon = true;

        if (this.selectedCompanyName) {
            compName = this.selectedCompanyName;
            compName = this.selectedCompanyName.Name
                ? this.selectedCompanyName.Name
                : this.selectedCompanyName;
        }

        if (compName == undefined || compName == "" || compName == null) {
            compName = "";
        }
        if (
            (this.selectedSubscriptionId.trim() != "" ||
            compName.trim() != "" ||
            this.selectedSubscriptionName != "" ||
                this.selectedSubscriptionAdmin.trim() != "" ||
                this.ApprovalPending != false ||
                this.IsActive != false ||
                this.IsHold != false ||
                this.IsInactive != false ||
                this.IsCancelled != false ||
                ((this.startDate != undefined || this.startDate != "") &&
                    (this.endDate != undefined || this.endDate != "")))

        ) {
            const inputData = {
                SubscriptionuniqeID: this.selectedSubscriptionId,
                SubscriptionName: this.selectedSubscriptionName,
                SubscriptionAdmin: this.selectedSubscriptionAdmin,
                SubscriptionType: this.selectedSubscriptionType,
                SubscriptionStatus: this.subscriptionStatusList.toString(),
                SessionAudience: this.subscriptionAudienceList.toString(),
                Company: compName,
                StartDate: this.sessionStartDate,
                EndDate: this.sessionEndDate,
            };

            this.subscriptionSearchService
                .getSubscriptionSearchData(inputData)
                .subscribe((res) => {
                    if (
                        res &&
                        res.subscriptionSearchResult &&
                        res.subscriptionSearchResult.length > 0
                    ) {
                        this.showTable = true;
                        this.showLoaderIcon = false;
                        this.setColumnHeading();
                        this.searchAreaFields = false;
                        this.seaerchAreaDownArrow = true;
                        this.seaerchAreaUpArrow = false;
                        this.showLoaderIcon = false;
                        this.setDataOnTabChange();
                        this.sampleData = res.subscriptionSearchResult.slice(0, 1000); // To print maximum 100 records
                        this.isEnableExportBtn = this.sampleData.length > 0 ? true : false;
                        this.totalRecords =
                            res.subscriptionSearchResult.length > 0
                                ? res.searchresultsCount
                                : 0;

                        this.searchGridHeightSet();
                    } else if (res && res.subscriptionSearchResult.length === 0) {
                        this.setColumnHeading();
                        this.showTable = true;
                        this.totalRecords = 0;
                        this.searchAreaFields = true;
                        this.seaerchAreaDownArrow = false;
                        this.seaerchAreaUpArrow = true;
                        this.showLoaderIcon = false;
                    }
                    
                });
        } else {
            this.showLoaderIcon = false;
            this.totalRecords = 0;
        }
    }

    resetSearch() {
        this.totalRecords = 0;
        this.searchAreaExpand();
        this.IsActive = false;
        this.ApprovalPending = false;
        this.IsHold = false;
        this.IsInactive = false;
        this.IsCancelled = false;
        this.ExternalClient = false;
        this.ExternalNonClient = false;
        this.MixedAudience = false;
        this.subscriptionStatusList = [];
        this.subscriptionAudienceList = [];
        this.selectedSubscriptionId = "";
        this.selectedSubscriptionName = ""
        this.selectedCompanyName = "";
        this.selectedSubscriptionAdmin = "";
        this.startDate = "";
        this.endDate = "";
        this.sessionStartDate = "";
        this.sessionEndDate = "";
        this.IsDateInvalid = false;
        this.invalidDateErrorMsg = "";
        this.enableSearchBtn = false;
        this.enableClearBtn = false;
        this.sampleData = [];
        this.isEnableExportBtn = false;
        this.showLoaderIcon = false;
        this.showTable = false;
        this.masterDataService.subscriptionSearchData = "";
        this.selectedSubscriptionType = "";
        this.setSubscriptionType(); // for country admin set subscription type to standard
        this.validateFields();
    }

    onChangeOfInputFields() {
        if (this.selectedCompanyName && (typeof (this.selectedCompanyName) === 'string'))
            this.selectedCompanyName = this.selectedCompanyName.replace(/^\s+|\s+$/gm, '');
        if (this.sampleData && this.sampleData.length > 0) {
            this.isEnableExportBtn = true;
        }
        if (this.selectedSubscriptionId === "   ") {
            this.enableSearchBtn = false;
            this.enableClearBtn = false;
          this.selectedSubscriptionId.trim();
        } else if (this.selectedSubscriptionName === "    ") {
          this.enableSearchBtn = false;
          this.enableClearBtn = false;
          this.selectedSubscriptionName.trim();
        }
        else if (this.selectedSubscriptionAdmin === "    ") {
            this.enableSearchBtn = false;
            this.enableClearBtn = false;
            this.selectedSubscriptionAdmin.trim();
        } else if (this.selectedSubscriptionType !== "") {
            this.enableSearchBtn = true;
            this.enableClearBtn = true;
        } else {
            if (
                this.selectedSubscriptionId !== "" ||
                this.selectedSubscriptionName !== "" ||
                (this.selectedCompanyName != undefined &&
                    this.selectedCompanyName != "") ||
                this.selectedSubscriptionAdmin !== "" ||
                this.selectedSubscriptionType !== "" ||
                this.ExternalClient !== false ||
                this.ExternalNonClient !== false ||
                this.MixedAudience !== false ||
                this.ApprovalPending !== false ||
                this.IsActive !== false ||
                this.IsHold !== false ||
                this.IsInactive !== false ||
                this.IsCancelled !== false ||
                (this.sessionStartDate != undefined &&
                    this.sessionStartDate != "" &&
                    this.sessionEndDate != undefined &&
                    this.sessionEndDate != "")
            ) {
                this.enableSearchBtn = true;
                this.enableClearBtn = true;
            } else {
                this.enableSearchBtn = false;
                this.enableClearBtn = false;
            }
        }

        if (this.sessionStartDate != "" && this.sessionEndDate == "") {
            this.invalidDateErrorMsg = "";
            this.enableSearchBtn = false;
            this.enableClearBtn = false;
        }
    }

    typeaheadOnSelect(event) {
        console.log("company autocomplete");
    }
}
